<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات بیماری"
        >
          <b-form @submit.prevent>
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col md="6">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        name="Title"
                        autocomplete="off"
                      />
                    </b-form-group>

                  </b-col>

                  <b-col md="6">
                    <b-form-group
                      label="دسته بندی"
                      label-for="SicknessCategory"
                    >
                      <z-sickness-category v-model="Form.SicknessCategoryId" />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1 mb-2">
                      <b-form-checkbox
                        v-model="Form.StopDiet"
                        name="StopDiet"
                        value="true"
                        class="custom-control-danger"
                      >
                        امکان استفاده از رژیم وجود ندارد.
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <div class="form-label-group">
                        <b-form-textarea
                          id="Description"
                          v-model="Form.Description"
                          name="Description"
                          autocomplete="off"
                          rows="3"
                          no-resize
                        />
                      </div>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col
                    md="12"
                    class="mt-1"
                  >
                    <b-form-group
                      label="توصیه"
                    />
                  </b-col>

                  <b-col cols="12">
                    <b-row
                      v-for="(item, index) in Form.SicknessRecommend"
                      :id="item"
                      :key="index"
                      ref="SicknessRecommend"
                      class="mb-1"
                    >

                      <b-col md="10">
                        <b-form-group>
                          <b-form-textarea
                            v-model="Form.SicknessRecommend[index]"
                            name="Description"
                            rows="2"
                            no-resize
                          />
                        </b-form-group>
                      </b-col>

                      <b-col
                        md="2"
                        class="mb-1"
                        style="display: flex; align-items: center;"
                      >
                        <template v-if="SicknessRecommendRemoveId !== index">
                          <b-button
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-danger"
                            class="btn-icon rounded-circle"
                            @click="removeSicknessRecommend(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle"
                            variant="outline-primary"
                            @click="cancelSicknessRecommend"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            class="btn-icon rounded-circle ml-1"
                            variant="outline-primary"
                            @click="confirmSicknessRecommend"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>

                    </b-row>
                  </b-col>

                  <b-col cols="12">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="gradient-info"
                      class="mb-1"
                      @click="addSicknessRecommend"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZSicknessCategory from '@/tools/sicknesscategory.vue'

export default {
  name: 'SicknessDetails',
  components: {
    ZSicknessCategory,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        StopDiet: false,
        Description: null,
        SicknessCategoryId: null,
        SicknessRecommend: [null],
      },
      SicknessRecommendRemoveId: null,
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.sickness.add
      if (this.$route.params.id) {
        url = this.$api.sickness.update
      }

      this.loading = true
      this.$http.post(
        url, this.Form,
      )
        .then(() => {
          this.back()
        }).finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.sickness.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addSicknessRecommend() {
      this.Form.SicknessRecommend.push(null)
    },
    removeSicknessRecommend(index) {
      this.SicknessRecommendRemoveId = index
    },
    confirmSicknessRecommend() {
      this.Form.SicknessRecommend.splice(this.SicknessRecommendRemoveId, 1)
      this.SicknessRecommendRemoveId = null
    },
    cancelSicknessRecommend() {
      this.SicknessRecommendRemoveId = null
    },
  },
}
</script>
<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss'
</style>
